import React from "react";
import { ButtonToolbar, Form, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import "./admin-group-create-panel.scss";

const AdminGroupFormBottomColumnNew = ({
  isView,
  isEdit,
  isSubmitting,
  isValid,
  setPanelVisibility,
  submitForm,
}) => {
  const EnterKeySubmission = (keyEvent, submitForm) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      submitForm && submitForm();
    }
  };

  const EnterKeyCancel = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      setPanelVisibility((prev) => ({ ...prev, showCancelPanel: true }));
    }
  };

  return (
    <Form.Row>
      <ButtonToolbar className="group-btn-container">
        {!isView && (
          <Button
            //ref={submitRef}
            className="btn-wide"
            type="submit"
            disabled={isSubmitting || !isValid}
            onKeyDown={(keyEvent) => EnterKeySubmission(keyEvent, submitForm)}
          >
            {isEdit ? "Save" : "Create"}
          </Button>
        )}
        <Button
          onKeyDown={(keyEvent) => EnterKeyCancel(keyEvent)}
          className="btn-wide btn-outlined"
          onClick={() => {
            setPanelVisibility((prev) => ({
              ...prev,
              showCancelPanel: true,
            }));
          }}
        >
          Cancel
        </Button>
      </ButtonToolbar>
    </Form.Row>
  );
};

AdminGroupFormBottomColumnNew.propTypes = {
  submitForm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setPanelVisibility: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isView: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
};

export default AdminGroupFormBottomColumnNew;
